import SectionLabel from "@/components/SectionLabel";
import { DIAGNOSTICS } from "@/data/services";
import { FlaskConical, Home, FileText } from "lucide-react";
import { Link } from "react-router-dom";

export default function Diagnostics() {
  return (
    <div>
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <SectionLabel>Diagnostic Services</SectionLabel>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900 max-w-3xl">
            Reliable diagnostics, trusted labs, prompt reports.
          </h1>
          <p className="mt-4 text-slate-600 max-w-2xl leading-relaxed">
            We coordinate with reputable labs to ensure accurate reports, transparent pricing,
            and home sample collection for common tests — so you can focus on getting better.
          </p>

          <div className="mt-8 grid sm:grid-cols-3 gap-3">
            {[
              { icon: FlaskConical, t: "Trusted Partner Labs" },
              { icon: Home,         t: "Home Sample Collection" },
              { icon: FileText,     t: "Digital Reports" },
            ].map((x, i) => (
              <div key={i} className="rounded-2xl border border-slate-200/70 p-5 aarogya-shadow bg-white">
                <x.icon className="h-6 w-6 text-[#0A6EBD]" />
                <div className="mt-3 font-semibold text-slate-800">{x.t}</div>
              </div>
            ))}
          </div>

          <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {DIAGNOSTICS.map((d, i) => (
              <div key={i} className="rounded-2xl border border-slate-200/70 p-5 bg-white aarogya-shadow"
                   data-testid={`diag-${i}`}>
                <div className="font-serif text-lg text-slate-900">{d.name}</div>
                <div className="mt-1 text-sm text-slate-600">{d.desc}</div>
              </div>
            ))}
          </div>

          <div className="mt-12 rounded-3xl p-8 bg-[#F1F6FB] border border-slate-200/60">
            <div className="font-serif text-2xl text-slate-900">Need a diagnostic test?</div>
            <p className="text-slate-600 mt-2">Book a consultation and Dr. Onkar will advise you on the right tests — no unnecessary panels.</p>
            <Link to="/appointment" className="mt-4 inline-flex rounded-full px-5 py-3 text-sm font-semibold text-white"
                  style={{ background: "#0A6EBD" }}>Book Consultation</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
